module.exports = __webpack_public_path__ + "img/5_irene_d.0d550929.png";